import React from 'react';

import './Laurels.css';
import {images, data} from "../../constants"
import { SubHeading} from '../../components';

const AwardCard = ({award: { title, subtitle}}) => (
  <div className="app__laurels-awards_card">

    <div className="app__laurels_award-card_content">
      <p className="p__cormorant" style={{color: "#dcca87"}} >{title}</p>
      <p className="p__cormorant" >{subtitle}</p>
    </div>
  </div>
)


const Laurels = () => (
  <div className='app__bg app__wrapper section__padding' id='awards'>
    <div className="app__wrapper_info">
      <SubHeading title= "Restaurant Reservation" />
      <h1 className="headtext__cormorant">Host Your Special Moments With Us!</h1>

      <div className="Weekly Special">
        {data.awards.map(award => (
          <AwardCard award = {award} key = {award.title} />
        ))}
      </div>
    </div>
    <div className="app__wrapper_img">
      <img src= {images.event} alt="event" />
    </div>
  </div>
);

export default Laurels;
